import styles from './Citation.module.css';

export function Citation({
  index,
  title,
  meta,
  href,
}: {
  index?: number;
  title: string;
  meta?: string;
  href?: string;
}) {
  const Tag = href ? 'a' : 'span';
  return (
    <Tag className={styles.root} href={href}>
      {index !== undefined && <sup className={styles.index}>{index}</sup>}
      <span className={styles.body}>
        {title}
        {meta && <small className={styles.meta}>{meta}</small>}
      </span>
    </Tag>
  );
}
